import { Link } from 'react-router';
import { useSelector } from 'react-redux';

import userSelectors from 'redux/user/userSelectors';

import RouteNames from 'router/routes';

import s from './btnProfile.module.css';

function BtnProfile() {
  const user = useSelector(userSelectors.user);

  return (
    <Link to={RouteNames.PROFILE} className={s.btn_profile} title="profile">
      {user?.avatarUrl ? (
        <img src={user.avatarUrl} alt="profile" />
      ) : (
        <p>{user?.name.charAt(0)}</p>
      )}
    </Link>
  );
}

export default BtnProfile;
